module.exports = __webpack_public_path__ + "img/hero-dropdown-search-nissan.35af92ec.png";